/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
/* eslint-disable no-mixed-operators */
/* eslint-disable no-undef */
/* eslint-disable jsx-a11y/alt-text */
import React, { useEffect, useState } from 'react'
import { Link, useLocation, useHistory } from 'react-router-dom'
import '../App.css'
import '../styles/MainContainer.css'
import TextArea from '../components/TextArea.tsx'
import { ReactComponent as BackIcon } from '../icons/back.svg'
import TopBar from '../components/TopBar'
import { apiUrl, chainNames, scanLinks } from '../utils/constants.ts'
import { useAccount, useSignMessage } from 'wagmi'
import { toast } from 'react-hot-toast'
import ClipLoader from 'react-spinners/ClipLoader'
import { Tooltip } from 'react-tooltip'

const EditProfile = () => {
  const location = useLocation()
  const history = useHistory()
  const normAddr = a => (a ? String(a).toLowerCase().trim() : '')
  const parseSearch = search => {
    try {
      return new URLSearchParams(search || '')
    } catch {
      return new URLSearchParams('')
    }
  }
  const params = React.useMemo(
    () => parseSearch(location?.search),
    [location?.search]
  )
  const addressRaw = params.get('address') || ''
  const chainRaw = params.get('chain') || ''
  const addressLc = (addressRaw || '').toLowerCase().trim()
  const effectiveChain = React.useMemo(() => {
    const n = Number(chainRaw)
    return Number.isFinite(n) && n > 0 ? n : undefined
  }, [chainRaw])

  const { address: walletAddress } = useAccount()
  const fetchCtlRef = React.useRef(null)
  const isReloadLogoutRef = React.useRef(false)
  // Track previous wallet, address, and chain context for aggressive logout
  const prevCtxRef = React.useRef({
    wallet: undefined,
    addr: undefined,
    chain: undefined
  })
  // Guard state updates after unmount
  const mountedRef = React.useRef(true)
  useEffect(() => {
    return () => {
      mountedRef.current = false
    }
  }, [])

  const safeSet =
    setter =>
    (...args) => {
      if (mountedRef.current) setter(...args)
    }

  useEffect(() => {
    try {
      const nav =
        performance && performance.getEntriesByType
          ? performance.getEntriesByType('navigation')[0]
          : null
      const isReload = nav
        ? nav.type === 'reload'
        : performance &&
          performance.navigation &&
          performance.navigation.type === 1

      if (isReload) {
        isReloadLogoutRef.current = true
        // Log out first so the new page is unauthenticated
        logoutDev().finally(() => {
          isReloadLogoutRef.current = false
          try {
            fetchAgentData(addressLc, effectiveChain)
          } catch (_) {}
        })
      }
    } catch (_) {}
  }, [])
  const [apiKey, setApiKey] = useState('')
  const [personality, setPersonality] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [isCorcel, setIsCorcel] = useState(true)
  const [tokenName, setTokenName] = useState('')
  const [tokenSymbol, setTokenSymbol] = useState('')
  const [tokenLogoUrl, setTokenLogoUrl] = useState('')
  const [prefillChainName, setPrefillChainName] = useState('')
  const [prefillChainLogo, setPrefillChainLogo] = useState('')

  const prefillMeta = React.useMemo(() => {
    try {
      if (!effectiveChain || !addressLc) return null
      const key = `editPrefill:${Number(effectiveChain)}:${String(
        addressLc
      ).toLowerCase()}`
      const raw =
        localStorage.getItem(key) || localStorage.getItem('editPrefill:last')
      return raw ? JSON.parse(raw) : null
    } catch {
      return null
    }
  }, [effectiveChain, addressLc])
  const [hasChainWarning, setHasChainWarning] = useState(false)
  // --- Dev auth (SIWE cookie session) ---
  const [isDevAuthed, setIsDevAuthed] = useState(false)
  const [authBusy, setAuthBusy] = useState(false)
  const [authError, setAuthError] = useState('')
  const [notDevForToken, setNotDevForToken] = useState(false)
  const { signMessageAsync } = useSignMessage()

  // Wrapped setters used in async flows (defined after state hooks)
  const _setAuthBusy = safeSet(setAuthBusy)
  const _setIsDevAuthed = safeSet(setIsDevAuthed)
  const _setNotDevForToken = safeSet(setNotDevForToken)
  const _setAuthError = safeSet(setAuthError)
  const _setHasChainWarning = safeSet(setHasChainWarning)
  const _setIsCorcel = safeSet(setIsCorcel)
  const _setApiKey = safeSet(setApiKey)
  const _setPersonality = safeSet(setPersonality)
  const _setTokenName = safeSet(setTokenName)
  const _setTokenSymbol = safeSet(setTokenSymbol)
  const _setIsLoading = safeSet(setIsLoading)

  // Normalize API base (strip trailing slash). Helps avoid //api paths.
  const API_BASE = React.useMemo(() => (apiUrl || '').replace(/\/$/, ''), [])

  // Helper to build a minimal SIWE message string
  // Helper to shorten addresses for display
  const shortAddr = React.useCallback(a => {
    const s = (a || '').toString()
    if (s.length <= 12) return s
    return `${s.slice(0, 6)}…${s.slice(-4)}`
  }, [])
  // Copy helper
  const copy = React.useCallback(async (text, label = 'copied') => {
    try {
      await navigator.clipboard.writeText(String(text || ''))
      toast.success(`${label}`)
    } catch (_) {
      toast.error('Copy failed')
    }
  }, [])

  // Chain label & explorer URL for the token address
  const chainLabel = React.useMemo(() => {
    if (prefillChainName) return prefillChainName
    if (!effectiveChain) return '—'
    const label = chainNames && chainNames[Number(effectiveChain)]
    return label || String(effectiveChain)
  }, [effectiveChain, prefillChainName])
  useEffect(() => {
    if (!prefillMeta) return
    if (prefillMeta?.name && !tokenName) setTokenName(prefillMeta.name)
    if (prefillMeta?.symbol && !tokenSymbol) setTokenSymbol(prefillMeta.symbol)
    if (prefillMeta?.logoUrl && !tokenLogoUrl)
      setTokenLogoUrl(prefillMeta.logoUrl)
    if (prefillMeta?.chainName && !prefillChainName)
      setPrefillChainName(prefillMeta.chainName)
    if (prefillMeta?.chainLogo && !prefillChainLogo)
      setPrefillChainLogo(prefillMeta.chainLogo)
  }, [prefillMeta])

  const explorerUrl = React.useMemo(() => {
    try {
      if (!effectiveChain || !addressLc) return null
      const base = scanLinks && scanLinks[Number(effectiveChain)]
      if (!base) return null
      return `${base.replace(/\/$/, '')}/address/${addressLc}`
    } catch (_) {
      return null
    }
  }, [effectiveChain, addressLc])
  const buildSiweMessage = ({ address, nonce, chainId }) => {
    const domain = window.location.host
    const uri = window.location.origin
    const issuedAt = new Date().toISOString()
    // Basic EIP-4361 formatted message
    return (
      `${domain} wants you to sign in with your Ethereum account:\n` +
      `${address}\n\n` +
      `Sign to access and modify agent settings (dev-only).\n\n` +
      `URI: ${uri}\n` +
      `Version: 1\n` +
      `Chain ID: ${chainId}\n` +
      `Nonce: ${nonce}\n` +
      `Issued At: ${issuedAt}`
    )
  }

  const authDev = async () => {
    try {
      if (!walletAddress) {
        toast.error('Connect wallet first')
        return
      }
      if (!effectiveChain) {
        toast.error('Missing chain in URL')
        return
      }
      _setAuthBusy(true)
      // 1) get nonce
      const nonceUrl = `${API_BASE}/api/auth/nonce`
      const nres = await fetch(nonceUrl, {
        method: 'GET',
        mode: 'cors',
        credentials: 'include'
      })
      if (!nres.ok) {
        const txt = await nres.text().catch(() => '')
        console.warn('[auth] nonce failed', nres.status, nres.statusText, txt)
        toast.error(`Failed to get nonce (${nres.status})`)
        _setAuthBusy(false)
        return
      }
      const { nonce } = await nres.json()
      // 2) snapshot context to avoid nonce/sign race
      const snapshot = {
        address: walletAddress,
        chainId: Number(effectiveChain)
      }
      // build message & sign using the snapshot
      const message = buildSiweMessage({
        address: snapshot.address,
        nonce,
        chainId: snapshot.chainId
      })
      const signature = await signMessageAsync({ message })
      // 3) verify (token-scoped) using the same snapshot
      const verifyUrl = `${API_BASE}/api/auth/verify`
      const vres = await fetch(verifyUrl, {
        method: 'POST',
        mode: 'cors',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          message,
          signature,
          tokenAddress: addressLc,
          chainId: snapshot.chainId
        })
      })
      if (!vres.ok) {
        let bodyText = ''
        let msg = ''
        try {
          const ct = vres.headers.get('content-type') || ''
          if (ct.includes('application/json')) {
            const j = await vres.json()
            msg = (j && j.message) || ''
            bodyText = JSON.stringify(j)
          } else {
            bodyText = await vres.text()
            try {
              msg = JSON.parse(bodyText).message || ''
            } catch {}
          }
        } catch {}
        console.warn(
          '[auth] verify failed',
          vres.status,
          vres.statusText,
          bodyText
        )
        const notDev =
          vres.status === 403 && /only the dev wallet/i.test(msg || bodyText)
        if (notDev) {
          _setNotDevForToken(true)
          _setAuthError(
            'This wallet is not the registered developer for this token. Connect the correct dev wallet and try again.'
          )
        } else {
          _setNotDevForToken(false)
          _setAuthError('Verification failed. Please try again.')
        }
        toast.error(`Verification failed (${vres.status})`)
        _setIsDevAuthed(false)
        _setAuthBusy(false)
        return
      }
      _setIsDevAuthed(true)
      _setNotDevForToken(false)
      _setAuthError('')
      toast.success('Dev wallet authenticated')
      // Refresh secrets if any
      await fetchAgentData(addressLc, effectiveChain)
    } catch (e) {
      console.warn('authDev error', e, {
        origin: window.location.origin,
        API_BASE
      })
      toast.error('Auth error (network)')
      _setIsDevAuthed(false)
    } finally {
      _setAuthBusy(false)
    }
  }
  // Dev-only: fetch sensitive agent document (if authed)
  const getAgentSensitive = async (addrLc, chainId, signal) => {
    if (!addrLc || !chainId) return null
    const safeAddr = encodeURIComponent(addrLc)
    const res = await fetch(
      `${API_BASE}/api/getAgentSensitive/${safeAddr}?chainId=${Number(
        chainId
      )}&_ts=${Date.now()}`,
      {
        method: 'GET',
        mode: 'cors',
        cache: 'no-store',
        signal,
        credentials: 'include'
      }
    )
    if (res.status === 401) {
      _setIsDevAuthed(false)
      return null
    }
    if (res.status === 403) {
      _setIsDevAuthed(false)
      return null
    }
    if (!res.ok) return null
    _setIsDevAuthed(true)
    try {
      return await res.json()
    } catch {
      return null
    }
  }

  const logoutDev = async () => {
    try {
      await fetch(`${API_BASE}/api/auth/logout`, {
        method: 'POST',
        mode: 'cors',
        credentials: 'include'
      })
    } catch {}
    _setIsDevAuthed(false)
    _setApiKey('')
    _setPersonality('')
    _setAuthError('')
    _setNotDevForToken(false)
  }

  // Best-effort auto logout when the tab is closed/refreshed or hidden
  const logoutBeacon = React.useCallback(() => {
    try {
      const url = `${API_BASE}/api/auth/logout`
      // Prefer fetch with keepalive + credentials (works during unload in modern browsers)
      const supportsKeepalive =
        typeof Request !== 'undefined' && 'keepalive' in Request.prototype
      if (supportsKeepalive && typeof fetch === 'function') {
        fetch(url, {
          method: 'POST',
          mode: 'cors',
          credentials: 'include',
          keepalive: true,
          headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
          body: ''
        }).catch(() => {})
        return
      }
      // Fallback to Beacon
      if (navigator.sendBeacon) {
        const payload = new Blob([], { type: 'text/plain;charset=UTF-8' })
        navigator.sendBeacon(url, payload)
      }
    } catch (_) {}
  }, [API_BASE])

  const forceLogoutAndGoBack = async () => {
    try {
      await logoutDev()
    } catch (_) {}
    // As a guard in case the above was blocked, also fire the beacon
    try {
      logoutBeacon()
    } catch (_) {}
    history.push('/profile')
  }

  useEffect(() => {
    const onVis = () => {
      if (document.visibilityState === 'hidden') logoutBeacon()
    }
    const onHide = () => logoutBeacon()
    const onBeforeUnload = () => logoutBeacon()

    document.addEventListener('visibilitychange', onVis)
    window.addEventListener('pagehide', onHide)
    window.addEventListener('beforeunload', onBeforeUnload)

    return () => {
      document.removeEventListener('visibilitychange', onVis)
      window.removeEventListener('pagehide', onHide)
      window.removeEventListener('beforeunload', onBeforeUnload)
    }
  }, [logoutBeacon])

  // Always fetch agent using LOWERCASED address + the chain from URL
  const getAgentLc = async (addrLc, chainId, signal) => {
    if (!addrLc || !chainId) return null
    const safeAddr = encodeURIComponent(addrLc)
    const res = await fetch(
      `${API_BASE}/api/getAgent/${safeAddr}?chainId=${Number(
        chainId
      )}&_ts=${Date.now()}`,
      {
        method: 'GET',
        mode: 'cors',
        cache: 'no-store',
        signal,
        credentials: 'include'
      }
    )
    if (res.status === 401 || res.status === 403) {
      _setIsDevAuthed(false)
      return null
    }
    if (!res.ok) return null
    // Public read succeeded; do NOT flip auth on. Only sensitive read or verify should set it true.
    try {
      return await res.json()
    } catch {
      return null
    }
  }

  // Fetch agent data strictly by normalized address + chain (allow override)
  const fetchAgentData = async (addrOverride, chainOverride) => {
    // abort previous in-flight agent fetch (if any)
    try {
      fetchCtlRef.current?.abort()
    } catch (_) {}
    fetchCtlRef.current = new AbortController()
    const { signal } = fetchCtlRef.current
    const addr = addrOverride || addressLc
    const ch = Number(chainOverride || effectiveChain)
    if (!addr || !ch) return
    try {
      // Try sensitive (dev-only). If forbidden or not authed, fall back to public masked response.
      let data = await getAgentSensitive(addr, ch, signal)
      if (!data) {
        data = await getAgentLc(addr, ch, signal)
      }
      if (
        data &&
        typeof data.chainId !== 'undefined' &&
        Number(data.chainId) !== Number(ch)
      ) {
        console.warn(
          '[EditProfile] server returned different chainId than requested',
          { requested: Number(ch), returned: Number(data.chainId) }
        )
        _setHasChainWarning(true)
        // continue: still show what server returned so the user sees current values
      } else {
        _setHasChainWarning(false)
      }
      if (data) {
        const providerFromServer =
          typeof data.provider === 'string'
            ? data.provider.toLowerCase()
            : undefined
        _setIsCorcel(
          typeof data.isCorcel === 'boolean'
            ? data.isCorcel
            : providerFromServer === 'corcel'
        )
        _setApiKey(data.apiKey || '')
        _setPersonality(data.personality || '')
        if (data.tokenName) _setTokenName(data.tokenName)
        if (data.tokenSymbol) _setTokenSymbol(data.tokenSymbol)
      } else {
        // Not authed or not found: mask secrets, keep non-secret
        if (!isDevAuthed) {
          _setApiKey('')
          _setPersonality('')
        }
      }
    } catch (e) {
      console.warn('getAgent fetch error', e)
    }
  }

  useEffect(() => {
    if (isReloadLogoutRef.current) return
    fetchAgentData(addressLc, effectiveChain)
  }, [addressLc, effectiveChain])

  useEffect(() => {
    setNotDevForToken(false)
    setAuthError('')
  }, [addressLc, effectiveChain, walletAddress])

  // Aggressive logout when wallet, token address, or chain changes
  useEffect(() => {
    const prev = prevCtxRef.current
    const curr = {
      wallet: walletAddress || undefined,
      addr: addressLc || undefined,
      chain: Number(effectiveChain) || undefined
    }

    const changed =
      prev.wallet !== curr.wallet ||
      prev.addr !== curr.addr ||
      prev.chain !== curr.chain

    // Update snapshot first
    prevCtxRef.current = curr

    if (!changed) return

    // If any critical context changed, aggressively end dev session, clear banners, and refetch public data
    setNotDevForToken(false)
    setAuthError('')

    // Avoid double logout on initial mount (when all were undefined)
    const isInitial =
      typeof prev.wallet === 'undefined' &&
      typeof prev.addr === 'undefined' &&
      typeof prev.chain === 'undefined'
    if (isInitial) return

    // If we were authed (or just to be safe), log out server-side and refetch
    logoutDev().finally(() => {
      try {
        fetchAgentData(addressLc, effectiveChain)
      } catch (_) {}
    })
  }, [walletAddress, addressLc, effectiveChain])

  useEffect(() => {
    if (!effectiveChain) {
      toast.error('Missing ?chain= in URL')
    }
  }, [effectiveChain])

  useEffect(() => {
    return () => {
      try {
        fetchCtlRef.current?.abort()
      } catch (_) {}
      try {
        logoutBeacon()
      } catch (_) {}
    }
  }, [logoutBeacon])

  // Save agent, POST using URL chain and lowercased tokenAddress, then re-fetch after save
  const saveAgent = async () => {
    if (!addressRaw) {
      toast.error('Missing token address in URL')
      return
    }
    if (!effectiveChain) {
      toast.error('Missing chain in URL')
      return
    }
    if (!walletAddress) {
      toast.error('Please connect your wallet to save settings')
      return
    }
    if (!isDevAuthed) {
      toast.error('Developer auth required')
      return
    }

    _setIsLoading(true)
    const sendData = {
      tokenAddress: (addressRaw || '').toLowerCase().trim(),
      creator: normAddr(walletAddress),
      chainId: Number(effectiveChain),
      apiKey: apiKey || '',
      personality: personality || '',
      isCorcel: !!isCorcel,
      provider: isCorcel ? 'corcel' : 'openai'
    }
    const url = `${API_BASE}/api/addAgent?chainId=${effectiveChain}`
    try {
      const res = await fetch(url, {
        method: 'POST',
        mode: 'cors',
        cache: 'no-cache',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        redirect: 'error',
        body: JSON.stringify(sendData)
      })

      if (!res.ok) {
        const text = await res.text().catch(() => '')
        console.warn(
          'addAgent non-OK:',
          res.status,
          res.statusText,
          text?.slice(0, 300)
        )
        toast.error(`Save failed (HTTP ${res.status}).`)
        _setIsLoading(false)
        return
      }

      // Try to parse returned JSON and confirm chain
      let savedDoc = null
      try {
        if (res.headers.get('content-type')?.includes('application/json')) {
          savedDoc = await res.json()
          if (
            savedDoc &&
            typeof savedDoc.chainId !== 'undefined' &&
            Number(savedDoc.chainId) !== Number(effectiveChain)
          ) {
            console.warn(
              '[EditProfile] POST returned a doc with different chainId',
              {
                expected: Number(effectiveChain),
                got: Number(savedDoc.chainId)
              }
            )
          }
        }
      } catch (_) {}

      // re-fetch with the exact same normalized address + chain to avoid mismatch
      await fetchAgentData(addressLc, Number(effectiveChain))
      toast.success(`Agent settings saved for chain ${effectiveChain}`)
    } catch (e) {
      console.warn('addAgent fetch error:', e)
      toast.error('Network error while saving')
    } finally {
      _setIsLoading(false)
    }
  }

  const canSave =
    !isLoading &&
    Boolean(isDevAuthed) &&
    Boolean(apiKey && apiKey.trim()) &&
    Boolean(personality && personality.trim()) &&
    Boolean(effectiveChain) &&
    Boolean(addressLc) &&
    Boolean(walletAddress)

  return (
    <div>
      <div className="GlobalContainer">
        <div style={{ zIndex: 1 }}>
          <TopBar />
          <div className="max-w-7xl m-auto pt-28 pb-20 px-4 sm:py-10">
            <div className="mb-2"></div>
            <div className="mb-2">
              <Link
                to={`/profile`}
                onClick={e => {
                  e.preventDefault()
                  forceLogoutAndGoBack()
                }}
                className="inline-flex items-center gap-1 text-[#f500ff] hover:text-[#f8ffe8] hover:underline"
              >
                ← go back
              </Link>
            </div>
            <section className="ProfileBox group rounded-xl border border-[#2a2d36] bg-[#171a21] text-[#f8ffe8] p-4 md:p-6 shadow-[0_0_8px_rgba(245,0,255,0.08)] hover:shadow-[0_0_16px_rgba(245,0,255,0.14)] hover:border-[#383c46] transition-all">
              <>
                <div className="flex flex-col gap-4">
                  <div className="w-full text-[20px] font-bold tracking-tight text-[#f8ffe8]">
                    agent settings
                  </div>
                  <div className="h-px bg-[#2a2d36]/60 -mx-2 md:-mx-4" />
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-5 w-full">
                    <section className="md:col-span-2 flex flex-col gap-3 w-full rounded-[12px] border border-[#2a2d36] bg-[#11141a] px-4 py-4">
                      <div className="flex items-start gap-4 md:gap-6">
                        {/* LEFT: picture */}
                        <div className="shrink-0">
                          {tokenLogoUrl ? (
                            <img
                              src={tokenLogoUrl}
                              className="h-16 w-16 md:h-20 md:w-20 rounded-lg border border-[#2a2d36] object-cover shadow-sm"
                            />
                          ) : (
                            <div className="h-16 w-16 md:h-20 md:w-20 rounded-lg border border-[#2a2d36] bg-[#171a21]" />
                          )}
                        </div>

                        {/* RIGHT: 3 stacked lines */}
                        <div className="flex-1 flex flex-col gap-2 min-w-0">
                          {/* Line 1: token info + chain (and explorer link on the far right for wide screens) */}
                          <div className="flex items-center justify-between gap-3">
                            <div className="flex items-center gap-3 min-w-0">
                              <div className="text-[13px] font-semibold tracking-wide text-[#f8ffe8] whitespace-nowrap">
                                coin info
                              </div>
                              {prefillChainLogo ? (
                                <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-[#171a21] border border-[#2a2d36] text-[11px] text-[#f8ffe8]/85">
                                  <img
                                    src={prefillChainLogo}
                                    className="h-4 w-4 rounded-full border border-[#2a2d36] object-cover"
                                  />
                                  {chainLabel}
                                </span>
                              ) : (
                                <span className="text-[11px] text-[#f8ffe8]/70">
                                  {chainLabel}
                                </span>
                              )}
                            </div>
                            {explorerUrl && (
                              <a
                                href={explorerUrl}
                                target="_blank"
                                rel="noreferrer noopener"
                                className="hidden sm:inline-block text-[11px] px-2.5 py-1.5 rounded-md border border-[#2a2d36] text-[#f8ffe8]/85 hover:text-[#f8ffe8] hover:bg-[#2a2d36]/30 transition-colors"
                                title="View on block explorer"
                              >
                                view on explorer ↗
                              </a>
                            )}
                          </div>

                          {/* Line 2: coin name and ticker */}
                          <div className="flex items-center gap-4 text-[14px] md:text-[15px] font-medium text-[#f8ffe8]">
                            <div className="truncate">
                              <span className="opacity-60">coin name:</span>{' '}
                              <span className="ml-1">{tokenName || '—'}</span>
                            </div>
                            <div className="truncate">
                              <span className="opacity-60">ticker:</span>{' '}
                              <span className="ml-1">{tokenSymbol || '—'}</span>
                            </div>
                          </div>

                          {/* Line 3: token address (short) + copy */}
                          <div className="flex items-center gap-2 text-[13px]">
                            <span className="opacity-60">token address:</span>
                            <code
                              className="font-mono text-[12px] opacity-90"
                              title={addressLc || ''}
                            >
                              {shortAddr(addressLc) || '—'}
                            </code>
                            {!!addressLc && (
                              <button
                                type="button"
                                onClick={() =>
                                  copy(addressLc, 'address copied')
                                }
                                className="text-[11px] px-1.5 py-0.5 rounded border border-[#2a2d36] text-[#f8ffe8]/75 hover:text-[#f8ffe8] hover:bg-[#2a2d36]/30"
                                title="Copy full address"
                              >
                                copy
                              </button>
                            )}
                          </div>

                          {/* mobile explorer button */}
                          {explorerUrl && (
                            <a
                              href={explorerUrl}
                              target="_blank"
                              rel="noreferrer noopener"
                              className="sm:hidden inline-flex w-fit text-[11px] px-2.5 py-1.5 rounded-md border border-[#2a2d36] text-[#f8ffe8]/85 hover:text-[#f8ffe8] hover:bg-[#2a2d36]/30 transition-colors"
                              title="View on block explorer"
                            >
                              view on explorer ↗
                            </a>
                          )}

                          {hasChainWarning && (
                            <div className="mt-1 inline-flex items-center gap-2 text-[11px] px-2 py-1 rounded bg-[#4b1f22] text-[#ffb4b4] border border-[#7a2b31] w-fit">
                              server returned different chain
                              <button
                                type="button"
                                className="underline hover:no-underline text-[#ffdede]"
                                onClick={() => {
                                  getAgentLc(addressLc, Number(effectiveChain))
                                    .then(d => {
                                      const srvChain = Number(d?.chainId)
                                      if (
                                        Number.isFinite(srvChain) &&
                                        srvChain > 0 &&
                                        srvChain !== Number(effectiveChain)
                                      ) {
                                        const usp = new URLSearchParams(
                                          location.search
                                        )
                                        usp.set('chain', String(srvChain))
                                        const newUrl = `${
                                          location.pathname
                                        }?${usp.toString()}`
                                        window.history.replaceState(
                                          null,
                                          '',
                                          newUrl
                                        )
                                        fetchAgentData(addressLc, srvChain)
                                      }
                                    })
                                    .catch(() => {})
                                }}
                              >
                                use server chain
                              </button>
                            </div>
                          )}
                        </div>
                      </div>
                    </section>
                    <section className="flex flex-col gap-3 w-full rounded-[12px] border border-[#2a2d36] bg-[#171a21] px-4 py-3">
                      <div className="LpBalance">
                        <div className="flex items-center text-[12px] text-[#f8ffe8]/60">
                          api key provider
                          <button
                            type="button"
                            className="flex pl-4 bg-transparent"
                            id="KeyProvider-anchor-element"
                            aria-label="Help: API key provider"
                          >
                            <Tooltip
                              anchorSelect="#KeyProvider-anchor-element"
                              className="w-64 md:w-80 lg:w-96 max-w-sm"
                              content={`Choose your Provider`}
                            />
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke="white"
                              strokeWidth={2}
                              className="h-5 w-5 cursor-pointer text-blue-gray-500"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z"
                              />
                            </svg>
                          </button>
                        </div>
                      </div>
                      <section className="inputPanel">
                        <section className="inputPanelHeader">
                          <div className="fairlaunch-allocation-buttons-container">
                            <button
                              className="fairlaunch-allocation-button border border-[#2a2d36] bg-[#2a2d36]/30 text-[#f8ffe8] hover:bg-[#2a2d36] hover:border-[#a135bb] aria-pressed:data-[on=true]:bg-[#2a2d36] aria-pressed:data-[on=true]:border-[#a135bb]"
                              onClick={() => setIsCorcel(true)}
                              aria-pressed={isCorcel === true}
                              data-on={isCorcel === true}
                              style={
                                isCorcel === true
                                  ? {}
                                  : {
                                      background: 'transparent',
                                      color: '#686c74',
                                      border: 'solid #686c74 1px'
                                    }
                              }
                              disabled={!isDevAuthed}
                            >
                              corcel
                            </button>
                            <button
                              className="fairlaunch-allocation-button border border-[#2a2d36] bg-[#2a2d36]/30 text-[#f8ffe8] hover:bg-[#2a2d36] hover:border-[#a135bb] aria-pressed:data-[on=true]:bg-[#2a2d36] aria-pressed:data-[on=true]:border-[#a135bb]"
                              onClick={() => setIsCorcel(false)}
                              aria-pressed={isCorcel === false}
                              data-on={isCorcel === false}
                              style={
                                isCorcel === false
                                  ? {}
                                  : {
                                      background: 'transparent',
                                      color: '#686c74',
                                      border: 'solid #686c74 1px'
                                    }
                              }
                              disabled={!isDevAuthed}
                            >
                              openai
                            </button>
                          </div>
                        </section>
                      </section>
                    </section>

                    <section className="flex flex-col gap-3 w-full rounded-[12px] border border-[#2a2d36] bg-[#171a21] px-4 py-3">
                      <div className="LpBalance">
                        <p
                          className="mt-1 text-[12px] font-medium text-[#f8ffe8]/70"
                          style={{ order: '0' }}
                        >
                          api key <span style={{ color: 'red' }}>*</span>
                        </p>
                      </div>
                      <TextArea
                        rows={4}
                        placeholder={
                          isDevAuthed ? 'Enter API Key' : '**************** '
                        }
                        changeValue={setApiKey}
                        value={isDevAuthed ? apiKey : ''}
                        aria-label="API Key"
                        disabled={!isDevAuthed}
                      />
                    </section>

                    <section className="md:col-span-2 flex flex-col w-full rounded-[12px] border border-[#2a2d36] bg-[#171a21] px-4 py-3">
                      <div className="LpBalance">
                        <p
                          className="mt-1 text-[12px] font-medium text-[#f8ffe8]/70"
                          style={{ order: '0' }}
                        >
                          personality <span style={{ color: 'red' }}>*</span>
                        </p>
                      </div>
                      <TextArea
                        rows={4}
                        placeholder={
                          isDevAuthed
                            ? 'Enter Personality'
                            : '************************************************************************************************************************************************************************************************'
                        }
                        changeValue={setPersonality}
                        value={isDevAuthed ? personality : ''}
                        aria-label="Agent personality"
                        disabled={!isDevAuthed}
                      />
                    </section>
                  </div>
                  <div className="mt-3 flex items-center justify-center gap-3">
                    {isDevAuthed ? (
                      <>
                        <button
                          className={`inline-flex items-center gap-2 px-4 py-2 rounded-lg border border-[#2a2d36] bg-[#2a2d36]/40 text-[#f8ffe8] hover:bg-[#2a2d36] hover:border-[#a135bb] text-sm transition-all hk-buzz ${
                            !canSave ? 'opacity-60 cursor-not-allowed' : ''
                          }`}
                          onClick={saveAgent}
                          disabled={!canSave}
                        >
                          {isLoading ? (
                            <ClipLoader
                              color={'#fff'}
                              loading={isLoading}
                              size={22}
                              aria-label="Loading Spinner"
                              data-testid="loader"
                            />
                          ) : (
                            'Save'
                          )}
                        </button>
                        <button
                          type="button"
                          className="inline-flex items-center gap-2 px-3 py-2 rounded-lg border border-[#2a2d36] bg-transparent text-[#f8ffe8]/80 hover:text-[#f8ffe8] hover:bg-[#2a2d36]/30 text-sm"
                          onClick={logoutDev}
                          disabled={authBusy}
                          title="Sign out dev session"
                        >
                          Sign out
                        </button>
                      </>
                    ) : (
                      <div className="flex flex-col items-center gap-2">
                        <button
                          type="button"
                          className={`inline-flex items-center gap-2 px-4 py-2 rounded-lg border border-[#2a2d36] ${
                            authBusy
                              ? 'bg-[#2a2d36]/40'
                              : 'bg-[#2a2d36]/30 hover:bg-[#2a2d36]'
                          } text-[#f8ffe8] text-sm`}
                          onClick={authDev}
                          disabled={authBusy || !walletAddress}
                        >
                          {authBusy ? (
                            <ClipLoader color={'#fff'} loading size={18} />
                          ) : (
                            'Authenticate dev wallet'
                          )}
                        </button>
                        <div className="text-[12px] text-[#f8ffe8]/60">
                          sign with your dev wallet to access & modify agent
                          details
                        </div>
                        {notDevForToken && (
                          <div className="mt-2 w-full max-w-xl rounded-md border border-[#7a2b31] bg-[#4b1f22] text-[#ffdede] p-3">
                            <div className="text-[13px] font-semibold mb-1">
                              Not the dev wallet
                            </div>
                            <div className="text-[12px] leading-snug opacity-90">
                              {authError ||
                                'This wallet is not authorized for this token.'}
                            </div>
                            <div className="mt-2 text-[12px] grid grid-cols-1 sm:grid-cols-2 gap-2">
                              <div className="flex items-center gap-2">
                                <span className="opacity-80">connected:</span>
                                <code className="font-mono text-[11px]">
                                  {shortAddr(walletAddress) || '—'}
                                </code>
                              </div>
                              <div className="flex items-center gap-2">
                                <span className="opacity-80">token:</span>
                                <code
                                  className="font-mono text-[11px]"
                                  title={addressLc}
                                >
                                  {shortAddr(addressLc)}
                                </code>
                              </div>
                              <div className="flex items-center gap-2">
                                <span className="opacity-80">chain:</span>
                                <span className="text-[11px]">
                                  {chainLabel}
                                </span>
                              </div>
                              {explorerUrl && (
                                <div className="flex items-center gap-2">
                                  <a
                                    href={explorerUrl}
                                    target="_blank"
                                    rel="noreferrer noopener"
                                    className="text-[11px] underline hover:no-underline"
                                  >
                                    view on explorer ↗
                                  </a>
                                </div>
                              )}
                            </div>
                            <div className="mt-2 flex flex-wrap gap-2">
                              <button
                                type="button"
                                onClick={() =>
                                  copy(addressLc, 'token address copied')
                                }
                                className="text-[11px] px-2 py-1 rounded border border-[#7a2b31] hover:bg-[#7a2b31]/40"
                              >
                                copy token address
                              </button>
                              <button
                                type="button"
                                onClick={() =>
                                  copy(walletAddress || '', 'wallet copied')
                                }
                                className="text-[11px] px-2 py-1 rounded border border-[#7a2b31] hover:bg-[#7a2b31]/40"
                              >
                                copy connected wallet
                              </button>
                            </div>
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </>
            </section>
          </div>
        </div>
      </div>
      {/* <Footer /> */}
    </div>
  )
}

export default EditProfile
